import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ContactPage from './pages/ContactPage';
import CompanyDetailPage from './pages/CompanyDetailPage';
import ExportsPage from './pages/ExportsPage';
import GroupCompaniesPage from './pages/GroupCompaniesPage';
import ReferencesPage from './pages/ReferencesPage';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/group-companies" element={<GroupCompaniesPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:slug" element={<ProductDetailPage />} />
            <Route path="/references" element={<ReferencesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/company/:slug" element={<CompanyDetailPage />} />
            <Route path="/exports" element={<ExportsPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
      </div>
    </Router>
  );
}

export default App;
